/* assets/feature-outline-fill-link.js */
;(function (){
let active=false, c1='', c2='';
const drop=()=>{const s=document.querySelector('#imported-Label')?.closest('svg');
  if(!s) return; ['--c1','--c2','--c3','--c4','--c5'].forEach(v=>s.style.removeProperty(v));};

function toggle(){
  if(!clickGuard()) return;
  const cur=paletteHub.get();
  if(!active){
    c1=cur.c1; c2=cur.c2;
    window.linkActive=true;
    paletteHub.set({c1:cur.c4,c2:cur.c3});
  }else{
    window.linkActive=false;
    paletteHub.set({c1:c1,c2:c2});
    drop();
  }
  active=!active;
}

(function waitBtn(){
  const b=[...document.querySelectorAll('text.st1-answer')]
    .find(t=>t.textContent.trim()==='Outline = Fill');
  if(!b) return setTimeout(waitBtn,200);
  b.style.cursor='pointer'; b.style.pointerEvents='all';
  b.addEventListener('click',()=>animQueue.run(toggle));
})();
})();
